<template>
  <div class="box cancal">
    <div class="box-head">
      <!-- <div class="head-name">项目统计</div> -->
      <el-menu
        :default-active="activeIndex2"
        class="el-menu-demo"
        mode="horizontal"
        @select="bentsSelect"
        background-color="#001498"
        text-color="#AECFDC"
        active-text-color="#AECFDC"
      >
        <el-menu-item index="/warnInfo" class="el-Page1" @click="hrefPage1">危险源监测预警信息</el-menu-item>
        <el-menu-item index="/saftManger" class="el-Page2" @click="hrefPage2">质量安全红线管理</el-menu-item>
      </el-menu>

      <div class="date" v-if="btn">
        <el-date-picker
          v-model="time"
          value-format="yyyy-MM-dd"
          type="date"
          @change="timeChange"
          placeholder="选择日期"
        ></el-date-picker>
      </div>
      <div class="date" v-else>
        <el-button type="warning" @click="openDetails">项目巡查</el-button>
      </div>
    </div>
    <div class="home-con">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import myHttp from '../../untils/port'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
    return {
      groupId: '',
      search: {
        name: ''
      },
      time: util.myTime.getCurTime(),
      activeIndex2: '/warnInfo',
      btn: true
    }
  },
  watch: {
    $route: {
      handler(newRouter) {
        var path =
          newRouter.matched && newRouter.matched.length > 2
            ? newRouter.matched[2].path
            : ''
        if (path == '/warnInfo') {
          this.btn = true
        } else {
          this.btn = false
        }
      }
    }
  },
  mounted() {
    // console.log()
    util.session.set('myTime', this.time), this.$store.commit('setTime')
    this.activeIndex2 = this.$route.path
    this.groupId = this.$store.state.groupId
    if ('' == this.groupId || undefined == this.groupId) {
      this.groupId = util.session.get('groupId')
    }
    var path =
      this.$route.matched && this.$route.matched.length > 2
        ? this.$route.matched[2].path
        : ''
    if (path == '/warnInfo') {
      this.btn = true
    } else {
      this.btn = false
    }
    // console.log(this.btn)
  },
  methods: {
    hrefPage1() {
      this.$router.push({ name: 'warnInfo' })
    },
    hrefPage2() {
      this.$router.push({ name: 'redLine' })
    },
    bentsSelect() {},
    openDetails() {
      // console.log(111)
      // util.session.set('proId', row.id)
      this.$router.push({ name: 'redDute' })
    },
    //时间改变
    timeChange(e) {
      var that = this
      util.session.set('myTime', e)
      that.$store.commit('setTime')
      // myHttp
      //   .secTowerWarningInfo({
      //     entId: '1238361259120742401',
      //     // projectId:'',
      //     joinType: '2',
      //     time: e
      //   })
      //   .then(
      //     function(resp) {
      //       if (resp.data.code == '200') {
      //         var list = resp.data.data.towerWarningInfo || []
      //         util.session.set('towerWarningInfo', list)
      //       } else {
      //         that.$message.error(resp.data.msg)
      //       }
      //     },
      //     function() {}
      //   )
    }
  }
}
</script>
<style scoped>
* {
  box-sizing: border-box;
}
.home-con {
  height: calc(100% - 60px);
}
.nowrap {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.box {
  width: 100%;
  position: relative;
  height:100%;
  /* background: #010d27; */
}
.box-head {
  width: 100%;
  height: 60px;
  position: relative;
  display: flex;
  padding: 0 40px;
  background: #001498;
  justify-content: space-between;
}
.head-name {
  display: flex;
  align-items: center;
  color: #aecfdc;
  font-size: 18px;
}
.head-num {
  flex: 1;
  padding: 0 20px;
  display: flex;
  align-items: center;
}
.head-search {
  width: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box .el-submenu {
  margin-right: 20px;
}
.box-table {
  width: 100%;
  height: calc(100% - 40px);
  position: relative;
  overflow: auto;
}
.box-table-item {
  width: 100%;
  height: 100px;
  margin-top: 15px;
  margin-bottom: 15px;
  background: #031260;
  display: flex;
  align-items: center;
  color: #aecfdc;
  box-sizing: border-box;
  font-size: 18px;
}
</style>
<style>
.head-search .el-input__inner {
  background: #020d4a;
  height: 30px;
  border: 0;
  line-height: 30px;
  color: #fff;
  border-radius: 15px;
}
.head-search .el-input__prefix {
  top: -4px;
}
.head-num .el-menu--horizontal {
  background: transparent;
  border-bottom: 0;
}
.head-num .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 40px;
  line-height: 40px;
  border-bottom: 0;
  color: #aecfdc;
  background: transparent;
  font-size: 18px;
}
.head-num .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  display: none;
}
.el-menu--horizontal .total-item {
  background-color: rgb(0, 20, 152);
  font-size: 16px;
  color: #ffffff !important;
}
.progress1 .el-progress-bar__outer {
  background-color: #001498;
}
.progress2 .el-progress-bar__outer {
  background-color: #4d7bf4;
}
.date {
  line-height: 60px;
  color: #fff;
}
.cancal .el-input__inner {
  background: transparent;
  border: 0;
  color: #4c9aff;
}

.cancal .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 150px;
}
</style>